/* ==========================================
   SNEAKER BUNDLE
========================================== */
document.addEventListener('DOMContentLoaded', () => {

// Only run this code on the Sneaker Bundle product
if (
  !window.location.pathname.includes(
    '/products/back-up-sneaker-car-air-freshener-refillable-ac-vent-clip-perfume-copy'
  )
) {
  return;
}


document.body.classList.add('cw-sneaker-bundle');
document.body.classList.add('cw-sneaker-simple');
  const imageMap = {
    Purple: 0,
    Green: 3,
    Red: 6,
    Blue: 9,
    Black: 12
  };

  // -----------------------------
  // Move bundle below price
  // -----------------------------
  function moveBundle() {

    const bundle = document.querySelector('[data-simple-bundles-options]');
    const price = document.querySelector('.productView-price');

    if (!bundle || !price) return;

    if (bundle.previousElementSibling !== price) {
      price.insertAdjacentElement('afterend', bundle);
    }

  }

  // -----------------------------
  // Build custom swatches
  // -----------------------------
  function buildSwatches(bundle) {

    // Remove previous UI if rebuilding
    document.querySelector('.cw-swatches-container')?.remove();

    const selects = bundle.querySelectorAll('select');

    if (!selects.length) return;

    const container = document.createElement('div');
    container.className = 'cw-swatches-container';

    selects.forEach((select, rowIndex) => {

      const row = document.createElement('div');
      row.className = 'cw-swatch-row';

      const label = document.createElement('div');
      label.className = 'cw-label';
      label.textContent = `Sneaker ${rowIndex + 1}`;

      const buttons = document.createElement('div');
      buttons.className = 'cw-buttons';

      [...select.options]
        .filter(option => option.value)
        .forEach(option => {

          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'cw-swatch';
          button.dataset.value = option.value;

          if (option.selected) {
            button.classList.add('active');
          }

          button.innerHTML = `
            <span class="dot"></span>
            <span>${option.value}</span>
          `;

          button.addEventListener('click', () => {

  select.value = option.value;

  select.dispatchEvent(
    new Event('change', { bubbles: true })
  );

  buttons.querySelectorAll('.cw-swatch')
    .forEach(btn => btn.classList.remove('active'));

  button.classList.add('active');

  const index = imageMap[option.value];

  if (index !== undefined) {
    $('.productView-for').slick('slickGoTo', index);
  }

});

          buttons.appendChild(button);

        });

      row.appendChild(label);
      row.appendChild(buttons);

      container.appendChild(row);

    });

    // Insert custom UI
    bundle.before(container);

    // Hide the original Simple Bundles UI
    setTimeout(() => {
      bundle.style.display = 'none';
    }, 100);

  }
// -----------------------------
// Rebuild bundle UI
// -----------------------------
function rebuild() {

  const bundle = document.querySelector('[data-simple-bundles-options]');

  if (!bundle) return;

  moveBundle();
  buildSwatches(bundle);

}
  // -----------------------------
  // Initialise
  // -----------------------------
  function init() {

  const bundle = document.querySelector('[data-simple-bundles-options]');

  if (!bundle) {
    setTimeout(init, 200);
    return;
  }

  rebuild();

}
init();

// -----------------------------
// Rebuild when Pack Size changes
// -----------------------------

let lastSelectCount = document.querySelector(
  '[data-simple-bundles-options]'
)?.querySelectorAll('select').length || 0;

document.querySelectorAll('input.product-form__radio').forEach(radio => {

  radio.addEventListener('change', () => {

    setTimeout(() => {

      const bundle = document.querySelector('[data-simple-bundles-options]');
      if (!bundle) return;

      const currentCount = bundle.querySelectorAll('select').length;

      if (currentCount !== lastSelectCount) {

        lastSelectCount = currentCount;

        rebuild();

      }

    }, 250);

  });

});
// -----------------------------
// Watch for Simple Bundles rebuilding
// -----------------------------
/* let rebuildTimer;

const observer = new MutationObserver(() => {

  clearTimeout(rebuildTimer);

  rebuildTimer = setTimeout(() => {
    rebuild();
  }, 100);

});

observer.observe(document.body, {
  childList: true,
  subtree: true
});*/
  // -----------------------------
  // Sync gallery when dropdown changes
  // -----------------------------
  document.addEventListener('change', e => {

    if (!e.target.closest('#simple-bundles-io-options')) return;

    const index = imageMap[e.target.value];

    if (index !== undefined) {
      $('.productView-for').slick('slickGoTo', index);
    }

  });

});

/* ==========================================
   COMFORT BUNDLE
========================================== */
document.addEventListener('DOMContentLoaded', () => {

  // Only run this code on the Comfort Bundle product
  if (
  !window.location.pathname.includes(
    '/products/complete-comfort-kit'
  )
) {
  return;
}

document.body.classList.add('cw-comfort-bundle');

console.log('Comfort Bundle Loaded ✅');

  function buildComfortPlaceholder() {

    // Find the Shopify Bundle Type selector
    const bundleType = document.querySelector('.productView-options');
    console.log('bundleType:', bundleType);

    if (!bundleType) {
      setTimeout(buildComfortPlaceholder, 200);
      return;
    }

    // Prevent duplicates
    if (document.querySelector('.cw-comfort-placeholder')) return;

    const box = document.createElement('div');

    box.className = 'cw-comfort-placeholder';

    box.innerHTML = `
<div class="cw-comfort-selector">

    <h3>Choose your comfort</h3>

    <div class="cw-grid">
    

        <!-- Header -->
        <div class="cw-head cw-head-label">Included</div>
        <div class="cw-head cw-head-essentials">Essentials</div>
        <div class="cw-head cw-head-plus cw-head-active">Plus</div>
        <div class="cw-head cw-head-ultimate">Ultimate</div>

        <!-- Neck Rest -->
        <div class="cw-name">Neck Rest</div>

        <div class="cw-cell cw-essentials">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-plus">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-ultimate">
            <span class="cw-dot"></span>
        </div>

        <!-- Back Rest -->
        <div class="cw-name">Back Rest</div>

        <div class="cw-cell cw-essentials">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-plus">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-ultimate">
            <span class="cw-dot"></span>
        </div>

        <!-- Armrest Cover -->
        <div class="cw-name">Armrest Cover</div>

        <div class="cw-cell cw-essentials"></div>

        <div class="cw-cell cw-plus">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-ultimate">
            <span class="cw-dot"></span>
        </div>

        <!-- Seatbelt Cover -->
        <div class="cw-name">Seatbelt Cover</div>

        <div class="cw-cell cw-essentials"></div>

        <div class="cw-cell cw-plus">
            <span class="cw-dot"></span>
        </div>

        <div class="cw-cell cw-ultimate">
            <span class="cw-dot"></span>
        </div>

        <!-- Steering Cover -->
        <div class="cw-name">Steering Cover</div>

        <div class="cw-cell cw-essentials"></div>

        <div class="cw-cell cw-plus"></div>

        <div class="cw-cell cw-ultimate">
            <span class="cw-dot"></span>
        </div>

    </div>

</div>
`;

  const colourFieldset = bundleType.querySelector(
  'fieldset[data-option-index="1"]'
);

if (colourFieldset) {
  colourFieldset.insertAdjacentElement('afterend', box);
} else {
  bundleType.after(box);
}
   
    // Create selection highlight
const grid = box.querySelector('.cw-grid');
const plusHeader = box.querySelector('.cw-head-plus');

const rect = plusHeader.getBoundingClientRect();
const gridRect = grid.getBoundingClientRect();

const highlight = document.createElement('div');

highlight.className = 'cw-selection-highlight';

highlight.style.position = 'absolute';
highlight.style.left = (rect.left - gridRect.left) + 'px';
highlight.style.top = (rect.bottom - gridRect.top + 8) + 'px';
highlight.style.width = (rect.width + 10) + 'px';
highlight.style.left = (rect.left - gridRect.left - 5) + 'px';
highlight.style.bottom = '0';

grid.style.position = 'relative';
grid.prepend(highlight);
function setActiveColumn(type) {

  // Remove active header
  headers.forEach(h => h.classList.remove('cw-head-active'));

  // Reset all dots to orange
  document.querySelectorAll('.cw-dot').forEach(dot => {
    dot.style.background = '#F58220';
  });

  let header;

  if (type === 'essentials') {
    header = box.querySelector('.cw-head-essentials');
    document.querySelectorAll('.cw-essentials .cw-dot').forEach(dot => {
      dot.style.background = '#1D4F91';
    });
  }

  if (type === 'plus') {
    header = box.querySelector('.cw-head-plus');
    document.querySelectorAll('.cw-plus .cw-dot').forEach(dot => {
      dot.style.background = '#1D4F91';
    });
  }

  if (type === 'ultimate') {
    header = box.querySelector('.cw-head-ultimate');
    document.querySelectorAll('.cw-ultimate .cw-dot').forEach(dot => {
      dot.style.background = '#1D4F91';
    });
  }

  header.classList.add('cw-head-active');

  const rect = header.getBoundingClientRect();

  highlight.style.left = (rect.left - gridRect.left - 5) + 'px';
  highlight.style.width = (rect.width + 10) + 'px';

}
const headers = box.querySelectorAll(
  '.cw-head-essentials, .cw-head-plus, .cw-head-ultimate'
);

headers.forEach(header => {

  header.style.cursor = 'pointer';

  header.addEventListener('click', () => {

    if (header.classList.contains('cw-head-essentials')) {

      document.querySelector(
        'label[for="option-8958999265416-Bundle\\ Type-0"]'
      )?.click();
      setActiveColumn('essentials');

    }

    if (header.classList.contains('cw-head-plus')) {

      document.querySelector(
        'label[for="option-8958999265416-Bundle\\ Type-3"]'
      )?.click();
      setActiveColumn('plus');

    }

    if (header.classList.contains('cw-head-ultimate')) {

      document.querySelector(
        'label[for="option-8958999265416-Bundle\\ Type-6"]'
      )?.click();
      setActiveColumn('ultimate');

    }

  });

});

// Default selected dots
document.querySelectorAll('.cw-plus .cw-dot').forEach(dot => {
    dot.style.background = '#1D4F91';
});

// Move colour selector below price
/*const options = document.querySelector('.productView-options');
const priceBlock = document.querySelector('.productView-price')?.parentElement;

if (options && priceBlock) {
    priceBlock.after(options);
}


*/
}


buildComfortPlaceholder();


// -----------------------------
// Sync gallery when colour changes
// -----------------------------
const comfortImageMap = {
  Red: 0,
  Pink: 7,
  Blue: 14
};

document.addEventListener('change', e => {

  if (e.target.name !== 'Colour') return;

  const index = comfortImageMap[e.target.value];

  if (index !== undefined) {
    $('.productView-for').slick('slickGoTo', index);
  }

});

});


/* ==========================================
   TRAFFIC SURVIVAL KIT
========================================== */
document.addEventListener('DOMContentLoaded', () => {

  if (!window.location.pathname.includes('/products/traffic-survival-kit')) {
    return;
  }

  document.body.classList.add('cw-traffic-kit');

  function buildImageSwatches(selectId, imageMap, zoom) {

    const select = document.getElementById(selectId);
    if (!select) return;

    // Only skip if THIS select already has swatches right before it
    if (select.previousElementSibling &&
        select.previousElementSibling.classList.contains('cw-tsk-swatches')) {
      return;
    }

    const container = document.createElement('div');
    container.className = 'cw-tsk-swatches';

    [...select.options]
      .filter(option => option.value)
      .forEach(option => {

        const imgSrc = imageMap[option.value];
        if (!imgSrc) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = zoom ? 'cw-tsk-swatch cw-tsk-swatch--zoom' : 'cw-tsk-swatch';
        button.dataset.value = option.value;

        if (option.selected) {
          button.classList.add('active');
        }

        button.innerHTML = `
          <span class="cw-tsk-img-wrap"><img src="${imgSrc}" alt="${option.value}"></span>
          <span>${option.value}</span>
        `;

        button.addEventListener('click', () => {

          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          container.querySelectorAll('.cw-tsk-swatch')
            .forEach(btn => btn.classList.remove('active'));

          button.classList.add('active');

        });

        container.appendChild(button);

      });

    select.style.display = 'none';
    select.before(container);

    const cueMap = {
      'sliding-panda-dashboard-decor': 'Pick your colour',
      'anti-hero-dangler': 'Pick your pose',
      'between-seat-car-organizer': 'Pick your colour',
      'magnetic-sunglasses-holder': 'Pick your colour',
      'record-player-perfume': 'Pick your disc',
      'tyre-valve-cap': 'Pick your colour'
    };

    const cueText = cueMap[selectId];

    if (cueText && !container.previousElementSibling?.classList?.contains('cw-tsk-cue')) {
      const cue = document.createElement('div');
      cue.className = 'cw-tsk-cue';
      cue.textContent = cueText;
      container.before(cue);
    }

  }
  function initSkatingPanda() {

    const select = document.getElementById('sliding-panda-dashboard-decor');

    if (!select) {
      setTimeout(initSkatingPanda, 200);
      return;
    }

    fetch('/products/sliding-panda-decor.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};

        product.variants.forEach(variant => {
          imageMap[variant.option1] = variant.featured_image
            ? variant.featured_image.src
            : product.featured_image.src;
        });

        buildImageSwatches('sliding-panda-dashboard-decor', imageMap);

      })
      .catch(err => console.error('SkatingPanda fetch failed:', err));

  }

  function initDangler() {

    const select = document.getElementById('anti-hero-dangler');

    if (!select) {
      setTimeout(initDangler, 200);
      return;
    }

    fetch('/products/deadpool-dangler.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};
        const options = [...select.options].filter(o => o.value);

        options.forEach((option, index) => {
          const variant = product.variants[index];
          if (variant) {
            imageMap[option.value] = variant.featured_image
              ? variant.featured_image.src
              : product.featured_image.src;
          }
        });

        buildImageSwatches('anti-hero-dangler', imageMap);

      })
      .catch(err => console.error('Dangler fetch failed:', err));

  }
function initOrganizer(attempts) {
    attempts = attempts || 0;

    const select = document.getElementById('between-seat-car-organizer');

    if (!select) {
      if (attempts < 10) {
        setTimeout(() => initOrganizer(attempts + 1), 200);
      }
      return;
    }

    fetch('/products/between-seat-organizer.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};

        product.variants.forEach(variant => {
          imageMap[variant.option1] = variant.featured_image
            ? variant.featured_image.src
            : product.featured_image.src;
        });

        buildImageSwatches('between-seat-car-organizer', imageMap);

      })
      .catch(err => console.error('Organizer fetch failed:', err));

  }

  function initVisorClip(attempts) {
    attempts = attempts || 0;

    const select = document.getElementById('magnetic-sunglasses-holder');

    if (!select) {
      if (attempts < 10) {
        setTimeout(() => initVisorClip(attempts + 1), 200);
      }
      return;
    }

    fetch('/products/bling-visor-clip.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};

        product.variants.forEach(variant => {
          imageMap[variant.option1] = variant.featured_image
            ? variant.featured_image.src
            : product.featured_image.src;
        });

        buildImageSwatches('magnetic-sunglasses-holder', imageMap);

      })
      .catch(err => console.error('Visor Clip fetch failed:', err));

  }
  function initRecordPlayer(attempts) {
    attempts = attempts || 0;

    const select = document.getElementById('record-player-perfume');

    if (!select) {
      if (attempts < 10) {
        setTimeout(() => initRecordPlayer(attempts + 1), 200);
      }
      return;
    }

    fetch('/products/record-player-car-perfume.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};
        const options = [...select.options].filter(o => o.value);

        options.forEach((option, index) => {
          const variant = product.variants[index];
          if (variant) {
            imageMap[option.value] = variant.featured_image
              ? variant.featured_image.src
              : product.featured_image.src;
          }
        });

        buildImageSwatches('record-player-perfume', imageMap);

      })
      .catch(err => console.error('Record Player fetch failed:', err));

  }
  function updateUpgradeHint() {

    document.querySelector('.cw-tsk-upgrade-hint')?.remove();

    const selectedRadio = document.querySelector('input[name="Tier"]:checked');
    if (!selectedRadio) return;

    const tier = selectedRadio.value;
    let message = '';

    if (tier === 'Essentials') {
      message = 'Plus unlocks 2 more items · Ultimate unlocks 4';
    } else if (tier === 'Plus') {
      message = 'Ultimate unlocks 2 more items';
    }

    if (!message) return;

    const hint = document.createElement('div');
    hint.className = 'cw-tsk-upgrade-hint';
    hint.textContent = message;

const optionsContainer = document.getElementById('simple-bundles-io-options');
    if (optionsContainer) {
      optionsContainer.after(hint);
    }

  }
  function moveWhyLoveSection() {

    const section = document.querySelector('.why-love-section');
    const buttonGroup = document.querySelector('.productView-group');

    if (section && buttonGroup && buttonGroup.previousElementSibling !== section) {
      buttonGroup.before(section);
    }

  }
  function initTyreValveCap(attempts) {
    attempts = attempts || 0;

    const select = document.getElementById('tyre-valve-cap');

    if (!select) {
      if (attempts < 10) {
        setTimeout(() => initTyreValveCap(attempts + 1), 200);
      }
      return;
    }

    fetch('/products/tyre-valve-caps.js')
      .then(res => res.json())
      .then(product => {

        const imageMap = {};

        product.variants.forEach(variant => {
          imageMap[variant.option1] = variant.featured_image
            ? variant.featured_image.src
            : product.featured_image.src;
        });

        buildImageSwatches('tyre-valve-cap', imageMap, true);

      })
      .catch(err => console.error('Tyre Valve Cap fetch failed:', err));

  }
function initAll() {
    initSkatingPanda();
    initDangler();
    initOrganizer();
    initVisorClip();
    initRecordPlayer();
    initTyreValveCap();
    updateUpgradeHint();
    moveWhyLoveSection();
  }

  function initAllWithRetry(attempts) {
    attempts = attempts || 0;

    initAll();

    const optionsContainer = document.getElementById('simple-bundles-io-options');
    const stillPlain = !optionsContainer ||
      optionsContainer.querySelector('select:not([style*="display: none"])');

    if (stillPlain && attempts < 30) {
      setTimeout(() => initAllWithRetry(attempts + 1), 500);
    }
  }

  initAllWithRetry();

  function attachObserver(attempts) {
    attempts = attempts || 0;

    const optionsContainer = document.getElementById('simple-bundles-io-options');

    if (!optionsContainer) {
      if (attempts < 30) {
        setTimeout(() => attachObserver(attempts + 1), 500);
      }
      return;
    }

    let rebuildTimer;

    const observer = new MutationObserver(() => {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(initAll, 150);
    });

    observer.observe(optionsContainer, {
      childList: true,
      subtree: true
    });

  }

  attachObserver();

  document.addEventListener('change', (e) => {
    if (e.target.name === 'Tier') {
      setTimeout(initAll, 300);
    }
  });

});

/* -----------------------------
   Disable hidden-tier fields before submit
   (prevents Record Player / Tyre Valve Cap from
   submitting stale values when their row isn't shown)
----------------------------- */
function disableHiddenTierFields() {

  const selectIds = [
    'sliding-panda-dashboard-decor',
    'anti-hero-dangler',
    'between-seat-car-organizer',
    'magnetic-sunglasses-holder',
    'record-player-perfume',
    'tyre-valve-cap'
  ];

  selectIds.forEach(id => {

    const select = document.getElementById(id);
    if (!select) return;

    const swatches = select.previousElementSibling;
    const isHidden = !swatches || swatches.offsetParent === null;

    select.disabled = isHidden;

  });

}

document.addEventListener('submit', (e) => {

  if (!e.target.matches('form[data-type="add-to-cart-form"]')) return;

  disableHiddenTierFields();

}, true);


/* ==========================================
   BUILD YOUR OWN BUNDLE — Grouped Swatches
========================================== */
document.addEventListener('DOMContentLoaded', () => {

  if (!window.location.pathname.includes('/products/build-your-own-bundle')) {
    return;
  }

  document.body.classList.add('cw-byob');

  function moveBundlePrice(attempts) {
    attempts = attempts || 0;

    const priceBlock = document.querySelector('.sb-dynamic-pdp-price');
    const anchor = document.querySelector('.productView-price');

    if (!priceBlock || !anchor) {
      if (attempts < 40) setTimeout(() => moveBundlePrice(attempts + 1), 500);
      return;
    }

    if (anchor.nextElementSibling !== priceBlock) {
      anchor.insertAdjacentElement('afterend', priceBlock);
    }

  }

  moveBundlePrice();

  // -----------------------------
  // Config: product name (text before dash) -> handle + mode
  // mode: 'color' = colored dots, 'thumbnail' = small image tiles
  // -----------------------------
  const PRODUCT_CONFIG = {
    'Neck Rest': { handle: 'memory-foam-neck-rest', mode: 'color' },
    'Back Rest': { handle: 'memory-foam-backrest-for-car-seat', mode: 'color' },
    'PU Armrest Cover': { handle: 'memory-foam-car-armrest-cover', mode: 'color' },
    'Suede Armrest Cover': { handle: 'suede-armrest-cover', mode: 'color' },
    'Seatbelt Cover': { handle: 'seat-belt-cover', mode: 'color' },

    'PU Steering Cover': { handle: 'pu-steering-cover', mode: 'color' },
    'Carbon Fibre Steering Cover': { handle: 'carbon-fiber-steering-cover', mode: 'color' },
    'Fabric Steering Cover': { handle: 'fabric-steering-cover', mode: 'color' },

    'Compact Seatback Organizer': { handle: 'compact-seatback-organizer', mode: 'color' },
    'Between Seat Organizer': { handle: 'between-seat-organizer', mode: 'color' },
    'Front Seat Organizer': { handle: 'seat-side-organizer', mode: 'color' },
    'Big Seatback Organizer': { handle: 'big-seatback-organizer', mode: 'color' },
    'Bling Car Hooks': { handle: 'bling-car-hooks', mode: 'color' },
    'Bling Phone Stand': { handle: 'bling-phone-stand', mode: 'color' },
    'Visor Clip': { handle: 'bling-visor-clip', mode: 'color' },

    'Skating Panda': { handle: 'sliding-panda-decor', mode: 'color' },
    'Panther Start Button Cover': { handle: 'black-panther-start-button-cover', mode: 'thumbnail' },
    'Bling Start Button Cover': { handle: 'bling-start-button-cover', mode: 'thumbnail' },
    'Anti-Hero Dangler': { handle: 'deadpool-dangler', mode: 'thumbnail' },
    'Devil Decor': { handle: 'devil-deco', mode: 'color' },
    'Tyre Valve Cap': { handle: 'tyre-valve-caps', mode: 'color' },
    'Door Handle Sticker': { handle: 'door-handle-stickers', mode: 'color' },
    'ORVM Cover': { handle: 'orvm-cover', mode: 'color' },

    'Flower Perfume': { handle: 'flower-car-perfume', mode: 'color' },
    'Sneaker Perfume': { handle: 'sneaker-car-perfume', mode: 'color' },
    'Record Player Perfume': { handle: 'record-player-car-perfume', mode: 'thumbnail' }
  };

  // -----------------------------
  // Per-product default swatch (overrides the "Red" default)
  // -----------------------------
  const DEFAULT_VARIANT = {
    'Record Player Perfume': 'Funky Disc',
    'Panther Start Button Cover': 'Black',
    'Bling Start Button Cover': 'Silver Crown',
    'Skating Panda': 'Black',
    'Bling Phone Stand': 'Black',
    'Bling Car Hooks': 'Red',
    'Visor Clip': 'Polychrome'
  };

  const ROW_DEFAULT_COLOR = {
    'choose-your-decor': 'Red',
    'choose-your-organizer': 'Navy',
    'choose-your-steering': 'Pink',
    'choose-your-comfort': 'Blue',
    'choose-your-perfume': 'Green'
  };

  // -----------------------------
  // Color name -> hex, for 'color' mode dots
  // -----------------------------
  const COLOR_HEX = {
    Red: '#DC2626', Pink: '#F48FB1', Blue: '#2563EB', Navy: '#1E3A5F',
    Teal: '#17A9C9', Turquoise: '#17A9C9', Green: '#16A34A', Purple: '#6D28D9',
    Maroon: '#7F1D1D', Silver: '#C0C0C0', Black: '#111111', 'Light Blue': '#7DD3FC',
    Gray: '#9CA3AF', Grey: '#9CA3AF', Polychrome: 'linear-gradient(135deg,#DC2626,#2563EB,#16A34A,#F59E0B)',
    Multicolor: 'linear-gradient(135deg,#DC2626,#2563EB,#16A34A,#F59E0B)',
    Multicolour: 'linear-gradient(135deg,#DC2626,#2563EB,#16A34A,#F59E0B)'
  };

  // -----------------------------
  // Per-product swatch color overrides — for cases where the same
  // color name photographs differently across products
  // -----------------------------
  const SWATCH_COLOR_OVERRIDE = {
    'Neck Rest': { Blue: '#7DD3FC' },
    'Back Rest': { Blue: '#7DD3FC' }
  };

  // -----------------------------
  // Some row-default colours go by other names on certain products
  // (e.g. "Blue" also matches "Turquoise" / "Light Blue" variants)
  // -----------------------------
 const COLOR_MATCH_ALIASES = {
    blue: ['blue', 'turquoise', 'light blue', 'sky blue']
  };

  // -----------------------------
  // Products where the card should preview the SECOND uploaded image
  // for each variant (the in-car/prop shot) instead of the first
  // (plain product shot) — without changing what's featured in Shopify
  // -----------------------------
  const USE_SECOND_IMAGE = new Set([
    'Front Seat Organizer',
    'Compact Seatback Organizer',
    'Big Seatback Organizer',
    'Between Seat Organizer',
    'Bling Phone Stand',
    'Bling Car Hooks',
    'Visor Clip'
  ]);

  // Strips invisible/odd whitespace so "Blue" and "Blue " (or a
  // hidden non-breaking space) are treated as the same value
  function normalizeVariant(s) {
    return (s || '')
      .replace(/\u00A0/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  // Finds the item matching a default colour name, trying an exact
  // (normalized) match first, then known aliases for that colour
  function findDefaultItem(items, defaultName) {
    if (!defaultName) return null;
    const target = normalizeVariant(defaultName);
    let match = items.find(i => normalizeVariant(i.variant) === target);
    if (match) return match;
    const aliases = COLOR_MATCH_ALIASES[target] || [];
    for (const alias of aliases) {
      match = items.find(i => normalizeVariant(i.variant) === alias);
      if (match) return match;
    }
    return null;
  }

  // -----------------------------
  // Custom product display order per row (hero products first)
  // Rows not listed here keep their natural/admin order
  // -----------------------------
  const PRODUCT_ORDER = {
    'choose-your-decor': [
      'Anti-Hero Dangler', 'Skating Panda', 'Panther Start Button Cover', 'Tyre Valve Cap',
      'Devil Decor', 'Door Handle Sticker', 'Bling Start Button Cover', 'ORVM Cover'
    ],
    'choose-your-organizer': [
      'Front Seat Organizer', 'Compact Seatback Organizer', 'Between Seat Organizer', 'Bling Phone Stand',
      'Big Seatback Organizer', 'Bling Car Hooks', 'Visor Clip'
    ],
    'choose-your-comfort': [
      'PU Armrest Cover', 'Neck Rest', 'Seatbelt Cover', 'Back Rest', 'Suede Armrest Cover'
    ],
    'choose-your-perfume': [
      'Sneaker Perfume', 'Record Player Perfume', 'Flower Perfume'
    ]
  };
  
  // -----------------------------
  // Split "Product - Value" on FIRST " - " only
  // -----------------------------
  function parseOption(text) {
    const idx = text.indexOf(' - ');
    if (idx === -1) return { product: text.trim(), variant: '' };
    return {
      product: text.slice(0, idx).trim(),
      variant: text.slice(idx + 3).trim()
    };
  }

  // -----------------------------
  // Fetch a product's variant images, keyed by option1 text (lowercased)
  // Falls back to positional index if text doesn't match
  // -----------------------------
  async function fetchVariantImages(handle, useSecond) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      const allImages = product.images || [];
      const byLabel = {};
      const byIndex = [];
      product.variants.forEach((v, i) => {
        let img = v.featured_image ? v.featured_image.src : product.featured_image.src;

        if (useSecond && v.featured_image && v.featured_image.position) {
          // position is 1-based, so this index is the very next image
          // after this variant's current featured image
          const nextImg = allImages[v.featured_image.position];
          if (nextImg) img = nextImg;
        }

        byIndex.push(img);
        if (v.option1) byLabel[v.option1.trim().toLowerCase()] = img;
      });
      return { byLabel, byIndex, fallback: product.featured_image ? product.featured_image.src : '' };
    } catch (err) {
      console.error(`BYOB: image fetch failed for ${handle}`, err);
      return { byLabel: {}, byIndex: [], fallback: '' };
    }
  }

  function imageFor(variantText, index, imgData) {
    const key = variantText.trim().toLowerCase();
    return imgData.byLabel[key] || imgData.byIndex[index] || imgData.fallback;
  }

  // -----------------------------
  // Build one grouped-card row for a given select
  // -----------------------------
async function buildGroupedSwatches(selectId) {

    const select = document.getElementById(selectId);
    if (!select) return;

    if (select.dataset.cwGrouped === 'true') return;
    select.dataset.cwGrouped = 'true';

    const options = [...select.options].filter(o => o.value);

    const groups = [];
    const groupIndex = {};

    options.forEach(option => {
      const { product, variant } = parseOption(option.value);
      if (!(product in groupIndex)) {
        groupIndex[product] = groups.length;
        groups.push({ product, items: [] });
      }
      groups[groupIndex[product]].items.push({
        variant,
        fullValue: option.value,
        selected: option.selected
      });
    });

   const customOrder = PRODUCT_ORDER[selectId];
    if (customOrder) {
      groups.sort((a, b) => {
        const ai = customOrder.indexOf(a.product);
        const bi = customOrder.indexOf(b.product);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      });
    }

    // -----------------------------
    // Force a sensible default: the FIRST product in this row's
    // custom order, shown in its row-default colour (or per-product
    // override). Overrides whatever Simple Bundles happened to
    // default to, so the swatch ring, the badge, and the preview
    // image all agree on the same product/colour.
    // -----------------------------
    const firstProductName = (customOrder && customOrder[0]) || groups[0].product;
    const firstGroup = groups.find(g => g.product === firstProductName) || groups[0];
    const firstDefaultName = DEFAULT_VARIANT[firstGroup.product] || ROW_DEFAULT_COLOR[selectId];
    const firstDefaultItem = findDefaultItem(firstGroup.items, firstDefaultName) || firstGroup.items[0];

    groups.forEach(g => g.items.forEach(i => { i.selected = false; }));
    firstDefaultItem.selected = true;

    if (select.value !== firstDefaultItem.fullValue) {
      select.value = firstDefaultItem.fullValue;
      select.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { programmatic: true } }));
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'cw-byob-row-wrapper';
    wrapper.dataset.rowId = selectId;

    const hint = document.createElement('p');

    hint.className = 'cw-byob-swipe-hint';
    hint.textContent = `${groups.length} options — swipe to see all`;
    wrapper.appendChild(hint);

    const container = document.createElement('div');
    container.className = 'cw-byob-cards';

    try {

      for (const group of groups) {

        const config = PRODUCT_CONFIG[group.product] || { handle: '', mode: 'color' };
        let imgData = { byLabel: {}, byIndex: [], fallback: '' };

        if (config.handle) {
          imgData = await fetchVariantImages(config.handle, USE_SECOND_IMAGE.has(group.product));
        }

        const rowDefaultColor = ROW_DEFAULT_COLOR[selectId];
        const defaultName = DEFAULT_VARIANT[group.product] || (config.mode === 'color' ? rowDefaultColor : null);
        const previewItem = findDefaultItem(group.items, defaultName) || group.items[0];

        const isCardActive = group.items.some(i => i.selected);

        const card = document.createElement('div');
        card.className = 'cw-byob-card';
        card.dataset.product = group.product;
        if (isCardActive) card.classList.add('cw-byob-card--active');

        if (isCardActive) {
          const badge = document.createElement('div');
          badge.className = 'cw-byob-in-cart';
          badge.textContent = 'In your cart';
          card.appendChild(badge);
        }

        const previewIndex = group.items.indexOf(previewItem);
        const mainImg = document.createElement('img');
        mainImg.className = 'cw-byob-card-img';
        mainImg.alt = group.product;
        mainImg.src = imageFor(previewItem.variant, previewIndex, imgData);
        card.appendChild(mainImg);

        const title = document.createElement('div');
        title.className = 'cw-byob-card-title';
        title.textContent = group.product;
        card.appendChild(title);

        const swatchRow = document.createElement('div');
        swatchRow.className = 'cw-byob-swatch-row';


        function selectItem(item, index) {

          select.value = item.fullValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          container.querySelectorAll('.cw-byob-card').forEach(c => {
            c.classList.remove('cw-byob-card--active');
            c.querySelector('.cw-byob-in-cart')?.remove();
          });
          container.querySelectorAll('.cw-byob-dot, .cw-byob-thumb').forEach(s => {
            s.classList.remove('active');
          });

          card.classList.add('cw-byob-card--active');
          const badge = document.createElement('div');
          badge.className = 'cw-byob-in-cart';
          badge.textContent = 'In your cart';
          card.insertBefore(badge, card.firstChild);

          swatchRow.querySelectorAll('.cw-byob-dot, .cw-byob-thumb')[index]?.classList.remove('preview');
          swatchRow.querySelectorAll('.cw-byob-dot, .cw-byob-thumb')[index]?.classList.add('active');
          mainImg.src = imageFor(item.variant, index, imgData);

        }

       card.style.cursor = 'pointer';
        card.addEventListener('click', (e) => {
          if (e.target.closest('.cw-byob-dot, .cw-byob-thumb')) return;
          selectItem(previewItem, previewIndex);
        });

        group.items.forEach((item, i) => {

          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = config.mode === 'color' ? 'cw-byob-dot' : 'cw-byob-thumb';
          swatch.dataset.value = item.fullValue;
          swatch.title = item.variant;

          if (item.selected) {
            swatch.classList.add('active');
          } else if (item === previewItem) {
            swatch.classList.add('preview');
          }

          if (config.mode === 'color') {
            const override = SWATCH_COLOR_OVERRIDE[group.product] && SWATCH_COLOR_OVERRIDE[group.product][item.variant];
            const hex = override || COLOR_HEX[item.variant] || '#ccc';
            swatch.style.background = hex;
          } else {
            const thumbImg = document.createElement('img');
            thumbImg.src = imageFor(item.variant, i, imgData);
            thumbImg.alt = item.variant;
            swatch.appendChild(thumbImg);
          }

          swatch.addEventListener('click', () => selectItem(item, i));

          swatchRow.appendChild(swatch);

        });

        card.appendChild(swatchRow);
        container.appendChild(card);

      }

      wrapper.appendChild(container);
      select.style.display = 'none';
      select.before(wrapper);

    } catch (err) {
      console.error('BYOB: CRASHED for', selectId, err);
    }

  }
  // -----------------------------
  // Initialise all 5 rows, with retry (Simple Bundles can render late)
  // -----------------------------
  const SELECT_IDS = [
    'choose-your-decor',
    'choose-your-organizer',
    'choose-your-steering',
    'choose-your-comfort',
    'choose-your-perfume'
  ];

  function initAll(attempts) {
    attempts = attempts || 0;

    const allPresent = SELECT_IDS.every(id => document.getElementById(id));

    if (!allPresent) {
      if (attempts < 40) setTimeout(() => initAll(attempts + 1), 500);
      return;
    }

    SELECT_IDS.forEach(id => buildGroupedSwatches(id));

  }

  initAll();

  function reorderRows(attempts) {
    attempts = attempts || 0;

    const container = document.getElementById('simple-bundles-io-options');
    if (!container) {
      if (attempts < 40) setTimeout(() => reorderRows(attempts + 1), 500);
      return;
    }
    if (container.dataset.cwReordered === 'true') return;

    const allBuilt = SELECT_IDS.every(id =>
      document.querySelector(`.cw-byob-row-wrapper[data-row-id="${id}"]`)
    );

    if (!allBuilt) {
      if (attempts < 40) setTimeout(() => reorderRows(attempts + 1), 300);
      return;
    }

    SELECT_IDS.forEach(id => {
      const select = document.getElementById(id);
      const wrapper = document.querySelector(`.cw-byob-row-wrapper[data-row-id="${id}"]`);
      const label = document.querySelector(`label[for="${id}"]`);
      if (label) container.appendChild(label);
      if (wrapper) container.appendChild(wrapper);
      if (select) container.appendChild(select);
    });

    container.dataset.cwReordered = 'true';

  }

  reorderRows();
  function initComparePrice(attempts) {
    attempts = attempts || 0;

    const priceValueEl = document.querySelector('[data-sb-dynamic-pdp-price-value]');
    if (!priceValueEl) {
      if (attempts < 40) setTimeout(() => initComparePrice(attempts + 1), 500);
      return;
    }

    function updateCompare() {

      const raw = priceValueEl.textContent.replace(/[^0-9.]/g, '');
      const current = parseFloat(raw);
      if (!current || isNaN(current)) return;

      const original = current / 0.85;
      const savings = original - current;

      let compareEl = priceValueEl.parentElement.querySelector('.cw-byob-compare');
      if (!compareEl) {
        compareEl = document.createElement('div');
        compareEl.className = 'cw-byob-compare';
        priceValueEl.after(compareEl);
      }

      const fmt = n => '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

      compareEl.innerHTML =
        '<span class="cw-byob-compare-was">' + fmt(original) + '</span>' +
        '<span class="cw-byob-compare-save">Save ' + fmt(savings) + ' (15%)</span>';

    }

    updateCompare();

    const priceObserver = new MutationObserver(updateCompare);
    priceObserver.observe(priceValueEl, { childList: true, characterData: true, subtree: true });

  }

  initComparePrice();

  function initSelectionProgress(attempts) {
    attempts = attempts || 0;

    const priceCard = document.querySelector('.sb-dynamic-pdp-price');
    if (!priceCard) {
      if (attempts < 40) setTimeout(() => initSelectionProgress(attempts + 1), 500);
      return;
    }

    const progress = document.createElement('div');
    progress.className = 'cw-byob-progress';
    priceCard.appendChild(progress);

    const touchedRows = new Set();

    function updateProgress() {
      progress.textContent = `${touchedRows.size} of ${SELECT_IDS.length} selected`;
      progress.classList.toggle('cw-byob-progress--done', touchedRows.size === SELECT_IDS.length);
    }

    updateProgress();

    document.addEventListener('change', (e) => {
      if (SELECT_IDS.includes(e.target.id) && !e.detail?.programmatic) {
        touchedRows.add(e.target.id);
        updateProgress();
      }
    });

  }

  initSelectionProgress();
  // Backup: watch for Simple Bundles rendering late/rebuilding
  // (watches the whole body since Simple Bundles can replace its
  // own container entirely after dynamic pricing recalculates)
  let byobRebuildTimer;
  const byobObserver = new MutationObserver(() => {
    clearTimeout(byobRebuildTimer);
    byobRebuildTimer = setTimeout(() => {
      SELECT_IDS.forEach(id => buildGroupedSwatches(id));
      reorderRows();
    }, 150);
  });
  byobObserver.observe(document.body, { childList: true, subtree: true });
});